function getMoveDirection(item, tac) {
  //Not implemented
  return 'center';
}

function moveSuperSection(section, superSection, diff, direction) {
  //Not implemented
}

function getChangeDimension(item) {
  //Not implemented
}

export default {
  getMoveDirection,
  moveSuperSection,
  getChangeDimension,
};
